<template>
  <Image :image="data.media" />
</template>

<script setup lang="ts">
defineProps<{
  data: any
}>()
</script>
